"use client";

import SubscriptionCompetitionsPrizesProvider from "./provider";
import SubscriptionCompetitionsPageContent from "./page-content";
import DeviceProvider from "../../../redux/features/device/DeviceProvider";
import "./prizes-competition.css";

const PrizesListPage = () => {
  return (
    <DeviceProvider>
      <SubscriptionCompetitionsPrizesProvider>
        <SubscriptionCompetitionsPageContent />
      </SubscriptionCompetitionsPrizesProvider>
    </DeviceProvider>
  );
};

export default PrizesListPage;
